<template>
  <div class="page-box decision-box">
    <div class="decision-head">
      <div class="decision-head-left">飞行中故障后风险评估</div>
      <div class="decision-head-right">
        <div class="decision-head-bt" @click="historyErroyRecord"><img src="@/assets/images/yi.png"/>历史记录</div>
        <div class="decision-head-bt active" @click="$router.push('/index')"><img src="@/assets/images/yi2.png"/>首页
        </div>
      </div>
    </div>
    <div class="decision-page">
      <div class="homepage-top" v-if="!errorRecordList.length">
        <div class="manage-top">
          <div class="manage-left">
            <img src="@/assets/images/icon3.png"/>
          </div>
          <div class="manage-right">
            <div class="manage-h">飞行故障风险评估</div>
            <div class="manage-p">飞行员完成故障信息的输入，启动系统识别飞机风险源</div>
          </div>
        </div>
        <div class="manage-bottom task-b">
          <img src="@/assets/images/qq4.png"/>
          <div class="p">暂无故障</div>
        </div>
      </div>
      <!--故障列表-->
      <div class="task-box" v-if="errorRecordList.length">
        <div class="task-top">
          <div class="manage-top">
            <div class="manage-left">
              <img src="@/assets/images/icon2.png"/>
            </div>
            <div class="manage-right">
              <div class="manage-h">飞行故障风险评估</div>
              <div class="manage-p">飞行员完成故障信息的输入，启动系统识别飞机风险源</div>
            </div>
          </div>
        </div>
        <div class="task-ul" @scroll="load($event)">
          <div class="task-li" v-for="(item,index) in errorRecordList">
            <div class="task-text">
              <div class="task-h">
                {{ item.planeType }}&nbsp;&nbsp;{{ item.flightNo }}&nbsp;&nbsp;{{ item.planeId }}（注册号）/
                {{ item.msn }}（MSN编号)
              </div>
              <div class="task-p">
                <div class="task-laber">{{ item.fullFaultMessage }}</div>
              </div>
            </div>
            <div class="task-bt" @click="goMalfunction(item)">进入查看</div>
          </div>
        </div>
      </div>
    </div>
    <div class="left-box">
      <el-dialog
          :visible="dialogVisible2"
          :before-close="closeHistory"
          @open="planeRiskRecordHistory"
          @close="queryHistory.number=1"
      >
        <div class="history-page">
          <div class="history-head">历史记录</div>
          <div class="history-input">
            <el-input @keyup.enter.native="changeHistoryList()" v-model="paramsHistory.flightNo"
                      placeholder="请输入关键词搜索"></el-input>
          </div>
          <div class="history-ul" @scroll="loadHistory($event)">
            <div class="history-li" v-for="(item,index) in errorRecordHistoryList" :key="item.id">
              <div class="history-top">
                <div class="history-text">
                  <div class="history-h">{{ item.fullFaultMessage }}</div>
                  <div class="history-p">{{ item.createTimeFormat }}</div>
                </div>
                <div class="history-bt" @click="goMalfunction(item)">进入查看</div>
              </div>
              <div class="history-bottom">
                <div class="history-laber">
                  <div class="history-left">记录状态</div>
                  <div v-if="item.socReview==='R0'" class="history-right active3">{{ SocReviewEnum[item.socReview] }}</div>
                  <div v-if="item.socReview==='R1'" class="history-right active4">{{ SocReviewEnum[item.socReview] }}</div>
                  <div v-if="item.socReview==='R2'" class="history-right active">{{ SocReviewEnum[item.socReview] }}</div>
                  <div v-if="item.socReview==='R3'" class="history-right active2">{{ SocReviewEnum[item.socReview] }}</div>
                  <div v-if="item.socReview==='R4'" class="history-right active4">{{ SocReviewEnum[item.socReview] }}</div>
                  <div v-if="item.socReview==='R5'" class="history-right active">{{ SocReviewEnum[item.socReview] }}</div>
                </div>
                <div class="history-laber">
                  <div class="history-left">记录编号</div>
                  <div class="history-right">{{ item.id }}</div>
                </div>
                <div class="history-laber">
                  <div class="history-left">飞机类型</div>
                  <div class="history-right">{{ item.planeType }}</div>
                </div>
                <div class="history-laber">
                  <div class="history-left">航班号</div>
                  <div class="history-right">{{ item.flightNo }}</div>
                </div>
                <div class="history-laber">
                  <div class="history-left">飞机编号</div>
                  <div class="history-right">{{ item.msn }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {planeRiskRecord, planeRiskRecordHistory} from "@/api/api";
import History from "@/components/History.vue";
import AddTaskDialog from "@/views/Eventhandling/components/AddTaskDialog.vue";

export default {
  name: "decision",
  components: {AddTaskDialog, History},
  data() {
    return {
      dialogVisible2: false,
      query: {
        number: 1,
        limit: 10,
      },
      queryHistory: {
        number: 1,
        limit: 10,
      },
      paramsHistory: {
        flightNo: "CSN",
        orderBy: JSON.stringify([{"name": "id", "direction": "DESC"}])
      },
      inputHistory: '',
      params: {
        type: 'R3',
        orderBy: JSON.stringify([{"name": "id", "direction": "DESC"}])
      },
      errorRecordList: [],
      errorRecordHistoryList: [],
      isHistory: false,
      isScroll: true,
      isScrollHistory: true,
      SocReviewEnum: {
        R0: "申请中",
        R1: "模拟机处理中",
        R2: "不通过",
        R3: "已反馈",
        R4: "SOC确认信息",
        R5: "系统拒绝"
      }
    }
  },
  mounted() {
    this.planeRiskRecordHistory()
    this.getPlaneRiskRecord()
  },
  methods: {

    async getPlaneRiskRecord() {
      this.isScroll = false
      const res = await planeRiskRecord(this.query)
      if (res.code === 'A00000' && res.data.length) {
        this.errorRecordList = [...this.errorRecordList, ...res.data]
        console.log(this.errorRecordList)
        this.isScroll = true
        if (res.data.length < 10) {
          this.isScroll = false
          //  this.$message.info('已全部加载完')
        }
      } else {
        this.isScroll = false
      }
    },
    load(e) {
      const sHeight = e.target.scrollHeight
      const sTop = e.target.scrollTop
      const cHeight = e.target.clientHeight
      if (sTop + cHeight + 50 >= sHeight && this.isScroll) {
        this.morePage()
      }
    },
    morePage() {
      this.query.number++
      this.getPlaneRiskRecord()
    },

    async planeRiskRecordHistory() {
      this.isScrollHistory = false
      const res = await planeRiskRecordHistory(this.queryHistory, this.paramsHistory)
      if (res.code === 'A00000' && res.data.length) {
        if (this.queryHistory.number === 1){
          this.errorRecordHistoryList = res.data
        } else {
          this.errorRecordHistoryList = [...this.errorRecordHistoryList, ...res.data]
        }
        this.isScrollHistory = true
        if (res.data.length < 10) {
          this.isScrollHistory = false
          //  this.$message.info('已全部加载完')
        }
      } else {
        this.isScrollHistory = false
      }
    },
    loadHistory(e) {
      const sHeight = e.target.scrollHeight
      const sTop = e.target.scrollTop
      const cHeight = e.target.clientHeight
      if (sTop + cHeight + 50 >= sHeight && this.isScrollHistory) {
        this.morePageHistory()
      }
    },
    morePageHistory() {
      this.queryHistory.number++
      this.planeRiskRecordHistory()
    },
    historyErroyRecord() {
      this.dialogVisible2 = true
    },
    changeHistoryList() {
      if (this.paramsHistory.flightNo === '') {
        this.paramsHistory.flightNo = null;
      }
      console.log(this.paramsHistory)
      this.errorRecordHistoryList = [];
      this.planeRiskRecordHistory()
    },
    goMalfunction(item) {
      // R0: "申请中",
      // R1: "模拟机处理中",
      // R2: "不通过",
      // R3: "已反馈",
      // R4: "SOC确认信息",
      // R5: "系统拒绝"
      if (['R0','R4'].includes(item.socReview)) {
        this.$router.push(`/Commitanalogdata/${item.id}/`)
      } else {
        this.$router.push(`/simulator/${item.id}/`)
      }
    },
    closeHistory() {
      this.dialogVisible2 = false
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .left-box .el-dialog__wrapper {
  display: block;

  .el-dialog {
    border-radius: 0;
  }
}

/deep/ .left-box .el-dialog {
  margin: 0 !important;
  background: #262D40;
  height: 100vh;
  width: 600px;

  .el-dialog__header {
    padding: 0;
  }

  .el-dialog__body {
    padding: 0;
    color: #fff;
  }

  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
    font-size: 20px;
  }

  .el-dialog__headerbtn {
    top: 22px;
  }
}

.history-head {
  padding: 24px 16px;
  font-size: 24px;
  text-align: left;
  line-height: 20px;
}

.history-input {
  background: #131B33;
  width: calc(100% - 32px);
  margin: auto;
  height: 45px;
  display: flex;
  align-items: center;
  border-radius: 8px;

  /deep/ .el-input__inner {
    background: none;
    color: #fff;
  }
}

.history-bottom {
  padding: 24px;

  .history-laber:last-child {
    margin-bottom: 0;
  }

  .history-laber {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;

    .history-left {
      opacity: 0.87;
      font-size: 14px;
    }

    .history-right {
      opacity: 0.9;
      font-size: 16px;
    }

    .history-right.active {
      color: #E07073;
    }

    .history-right.active2 {
      color: #8EBF86;
    }

    .history-right.active3 {
      color: #EBA967;
    }

    .history-right.active4 {
      color: #2769EC;
    }
  }
}

.history-ul {
  padding: 16px;
  border-top: 1px solid #171E2F;
  margin-top: 20px;
  height: calc(100vh - 136px);
  padding-bottom: 0;
  box-sizing: border-box;
  overflow: auto;

  .history-li {
    background: #393F52;
    border: 1px solid #525F89;
    border-radius: 16px;
    margin-bottom: 16px;

    .history-top {
      display: flex;
      padding: 24px;
      justify-content: space-between;
      border-bottom: 1px solid #000000;

      .history-text {
        text-align: left;
        width: 370px;

        .history-h {
          font-size: 16px;
          color: rgba(255, 255, 255, 0.87);
          margin-bottom: 10px;
        }

        .history-p {
          color: rgba(255, 255, 255, 0.7);
          font-size: 12px;
        }
      }

      .history-bt {
        background: #4E5569;
        border-radius: 8px;
        font-size: 14px;
        cursor: pointer;
        padding: 0 20px;
        height: 34px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/eventinitiation/eventinitiation.vue